var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 1377,
    transform: "translate(-32 -599)",
    fill: "#F4F4F6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_101_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16 -249C-16 -253.418 -12.4183 -257 -8 -257H319C323.418 -257 327 -253.418 327 -249V93C327 97.4183 323.418 101 319 101H-8.00001C-12.4183 101 -16 97.4183 -16 93V-249Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_101_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.49951 3.49805H8.49951M4.49951 8.49805H8.49951M4.49951 5.49755H7.49951M4.49951 10.4985H7.49951M10.5 3.49805H11.499M10.5 8.49805H11.499M10.5 5.49755H11.499M10.5 10.4985H11.499",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00675 1.00146V14.9955L3.5015 13.999L5.0175 14.9985L6.51175 13.999L8.01175 14.9955L9.50625 13.999L11.0057 14.9955L12.501 13.999L14 14.9955V1.00146M0.5 1.00146H15.5M11.0057 14.9985V14.9955V14.9985ZM8.01175 14.9985V14.9955V14.9985Z",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_3",
    x: -32,
    y: -269,
    width: 375,
    height: 390,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.356863 0 0 0 0 0.388235 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 1377,
    fill: "white",
    transform: "translate(-32 -599)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_101_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/InvoiceIcon.a952a6deee1ae928b38ed4006c2e55ee.svg";
export { ForwardRef as ReactComponent };